<template>
  <div class="container-fluid">
    <validation-observer ref="simpleRules">
      <b-card>
        <b-row>
          <!-- basic select -->

          <!-- select with icon -->
          <b-col md="6">
            <span class="baslik">Sektör Adı</span>

            <br>

            <b-form-group class="color">
              <v-select
                v-model="selected1"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="books"
                label="title"
              >
                <template #option="{ title}">

                  <span> {{ title }}</span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <span class="baslik">Hesap Kodu</span>

            <br>

            <b-form-group class="color">
              <v-select
                v-model="selected1"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="books"
                label="title"
              >
                <template #option="{ title }">

                  <span> {{ title }}</span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <div class="demo-inline-spacing">

              <b-form-radio
                v-model="Selected"
                name="some-radio9"
                value="ff"
                class="custom-control-secondary"
              >
                Manuel Giriş
              </b-form-radio>

              <b-form-radio
                v-model="Selected"
                name="some-radio9"
                value="j"
                class="custom-control-info"
              >
                Otomatik Giriş
              </b-form-radio>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-form>
        <b-card
          class="text-center"
          title="Tüketim Sayacı Bilgileri"
        ><hr>
          <b-row class="sag">
            <b-list-group><br>
              <b-list-group-item>
                <p> Aktif Enerji</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Gündüz</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Gece</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Puant</p>
              </b-list-group-item>
            </b-list-group>

            <b-col md="1">
              <b-form-group>
                <label>İlk Endeks</label>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--Enter Number between 10 & 20 -->
            <b-col md="1">
              <b-form-group>
                <label>Son Endeks </label>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Must only consist of numbers-->
            <b-col md="1">
              <b-form-group>
                <label>Tüketim</label>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Must match the specified regular expression : ^([0-9]+)$ - numbers only -->
            <b-col md="1">
              <b-form-group>
                <label>Trafo Kaybı</label>
                <validation-provider
                  #default="{ errors }"
                  name="Regex"
                >
                  <b-form-input
                    v-model="numberRegx"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Regex"
                >
                  <b-form-input
                    v-model="numberRegx"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Regex"
                >
                  <b-form-input
                    v-model="numberRegx"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Regex"
                >
                  <b-form-input
                    v-model="numberRegx"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--  Only alphabetic characters-->
            <b-col md="1">
              <b-form-group>
                <label>Ek Tüketim</label>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <b-form-group>
                <label>Birim Fiyatı</label>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Alpha"
                >
                  <b-form-input
                    v-model="Alphabetic"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Length should not be less than the specified length : 3 -->
            <b-col md="2">
              <b-form-group>
                <label class="text-center">Toplam Tüketim</label>
                <validation-provider
                  #default="{ errors }"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <label class="text-right">Fatura Bedeli</label>
                <validation-provider
                  #default="{ errors }"
                  rules="required|min:3"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  rules="required|min:3"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  rules="required|min:3"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  rules="required|min:3"
                  name="Min Character"
                >
                  <b-form-input
                    v-model="digitValue"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--Password Input Field -->

            <!-- submit button -->

          </b-row>
        </b-card>
      </b-form>
      <b-form>
        <b-card
          class="text-center"
          title="Üretim Sayaç Bilgileri"
        ><hr>
          <b-row class="sag">
            <b-list-group><br>
              <b-list-group-item>
                <p> Aktif Enerji</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Gündüz</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Gece</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Puant</p>
              </b-list-group-item><hr>
              <b-list-group-item>
                <p>İndüktif</p>
              </b-list-group-item><br>
              <b-list-group-item>
                <p>Kapasitif</p>
              </b-list-group-item>

            </b-list-group>

            <b-col md="1">
              <b-form-group>
                <label>İlk Endeks</label>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="First Name"
                >
                  <b-form-input
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>

            <!--Enter Number between 10 & 20 -->
            <b-col md="1">
              <b-form-group>
                <label>Son Endeks </label>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number between"
                >
                  <b-form-input
                    v-model="numberRange"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Must only consist of numbers-->
            <b-col md="1">
              <b-form-group>
                <label>Üretim</label>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Number"
                >
                  <b-form-input
                    v-model="number"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Must match the specified regular expression : ^([0-9]+)$ - numbers only -->

            <!--  Only alphabetic characters-->

            <!-- Length should not be less than the specified length : 3 -->

            <!--Password Input Field -->

            <!-- submit button -->

          </b-row>
        </b-card>
      </b-form>
      <div
        id="butonkaydir"
        class="demo-inline-spacing"
      >

        <b-button variant="relief-secondary">
          Kesme Emri
        </b-button>
        <b-button variant="relief-info">
          Sözleşme
        </b-button>
        <b-button variant="relief-danger">
          Temizle
        </b-button>
        <b-button variant="relief-warning">
          Güncelle
        </b-button>
        <b-button variant="relief-dark">
          Excele At
        </b-button>
        <b-button variant="relief-success">
          Kaydet
        </b-button>

      </div>
    </validation-observer>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BListGroup, BCard, BFormRadio,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BListGroup,
    BCard,
    vSelect,
    BFormRadio,
  },
  data() {
    return {
      selected: { title: 'Nace Kodu / Cari Hesap' },
      selected1: {
        title: '-',
        icon: 'ApertureIcon',
      },
      option: [{ title: '-' }, { title: '-' }, { title: '-' }, { title: '-' }],
      books: [
        {
          title: '-',
          icon: 'ApertureIcon',
        },
        {
          title: '-',
          icon: 'CodepenIcon',
        },

      ],
    }
  },
}
</script>

<style>
.sag{
    text-align: center;
  margin-left: 3rem;
}
.color{
  background-color: bisque;
}
.baslik{
  float: center;
margin-left: 8rem;

}
#butonkaydir{
  float: center;

}
hr {
background-color: rgba(192, 40, 40, 0.726);
border: 0 none;
color: rgb(238, 238, 238);
height: 2px;
width: 100%;
}

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
